"use strict";

/* General + Third-Party */
import jQuery from 'jquery';
import { lazyload } from './globals/lazyload';
import Alpine from 'alpinejs'

// Access Apline function to the window object
window.Alpine = Alpine

/* Layout-Parts */
import { kkNavigationSubNav } from './layout/navigation';

/* Partials */
import { kkNextgenGalleries } from './partials/nextgen-galleries';

/* Blocks */
import { kkVideoTextMedia } from '../../blocks/text-media/script';
import { kkTeaserSlider } from '../../blocks/teaser-slider/script';
// import { kkLogoSlider } from '../../blocks/logo-slider/script';
import { kkStepsScrollAnim } from '../../blocks/steps/script';
import { kkTableFancybox } from '../../blocks/table/script';
import { kkGallerySliderInit } from '../../blocks/gallery/script';
import { kkLogoSlider } from '../../blocks/logo-slider/script';


jQuery(document).ready(_ => {
  // General + Third-Party
  Alpine.start();
  lazyload();

  //Layout-Parts
  kkNavigationSubNav();

  //Blocks
  kkVideoTextMedia();
  kkTeaserSlider();
  kkLogoSlider();
  kkStepsScrollAnim();
  kkTableFancybox();
  kkGallerySliderInit();

  // Partials
  kkNextgenGalleries();
});
